import { getFacilities } from '@lib/api'
import { facilitiesKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useFacilities = () => {
  return useQuery(facilitiesKeys.all, () => getFacilities())
}
